import { objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

import type { PutDecisioningStudioAgentsAppGroupIdDsaIdDetailsResult } from "./types";

export const isGetDecisioningStudioAgentsAppGroupIdDsaIdDetailsResult = objectOf({
  name: string,
  description: string,
});

export const isPutDecisioningStudioAgentsAppGroupIdDsaIdDetailsResult =
  objectOf<PutDecisioningStudioAgentsAppGroupIdDsaIdDetailsResult>({ status: string });
